"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIGURATION_KEYS = void 0;
const index_1 = require("./index");
/* tslint:disable:no-object-literal-type-assertion */
const baseName = "dashboardAPI";
exports.CONFIGURATION_KEYS = {
    charts: {
        prSizeToMergeTime: {
            fastMergeTimeThresholdMs: {
                name: `${baseName}.charts.prSizeToMergeTime.fastMergeTimeThresholdMs`,
                chain: [index_1.ConfigurationEntityType.Team],
                type: {}
            },
            slowMergeTimeThresholdMs: {
                name: `${baseName}.charts.prSizeToMergeTime.slowMergeTimeThresholdMs`,
                chain: [index_1.ConfigurationEntityType.Team],
                type: {}
            },
            slowMergeTimeHoursSizeRatio: {
                name: `${baseName}.charts.prSizeToMergeTime.slowMergeTimeHoursSizeRatio`,
                chain: [index_1.ConfigurationEntityType.Team],
                type: {}
            },
            maxDaysDisplay: {
                name: `${baseName}.charts.prSizeToMergeTime.maxDaysDisplay`,
                chain: [index_1.ConfigurationEntityType.Team],
                type: {}
            },
            maxSizeDisplay: {
                name: `${baseName}.charts.prSizeToMergeTime.maxSizeDisplay`,
                chain: [index_1.ConfigurationEntityType.Team],
                type: {}
            },
        }
    },
    devCycles: {
        name: `${baseName}.devCycles`,
        chain: [index_1.ConfigurationEntityType.Team],
        type: {}
    }
};
//# sourceMappingURL=dashboard-api.js.map